module.exports = __webpack_public_path__ + "img/pricing-icon-white.13239ff7.png";